import Vue from "vue";
import postService from "../../services/post/post";
import { Post } from "../../services/post/entities/post.interface";
import { uploadTask, deleteTask } from "../../firebase";
import constants from "../../config/constants";
import { PostState } from "./states/post.state.interface";

export default {
  namespaced: true,
  state: {
    posts: [],
    totalPosts: 0
  },
  getters: {
    getPosts: (state: PostState) => state.posts,
    getTotalPosts: (state: PostState) => state.totalPosts
  },
  mutations: {
    setPosts(state: PostState, posts: Array<Post>) {
      Vue.set(state, "posts", posts);
    },
    setTotalPosts(state: PostState, totalPosts: number) {
      Vue.set(state, "totalPosts", totalPosts);
    }
  },
  actions: {
    getPosts: async (context: any, payload: any) => {
      context.commit("setPosts", []);
      await postService.getPosts(payload).then((response: any) => {
        context.commit("setTotalPosts", response.data.totalPosts);
        context.commit("setPosts", response.data.posts);
      });
    },
    getPostsToClient: async (context: any, payload: any) => {
      context.commit("setPosts", []);
      await postService.getPostsToClient(payload).then((response: any) => {
        context.commit("setTotalPosts", response.data.totalPosts);
        context.commit("setPosts", response.data.posts);
      });
    },
    createPost: async (context: any, payload: any) => {
      let created = false;
      created = true;
      await postService.createPost(payload).then(async (response: any) => {
        created = response.data.created;

        if (!payload.hosted) {
          const mediaURL =
            payload.mediaUrl !== null
              ? await uploadTask(
                  `media${response.data.postID}`,
                  constants.TABLE.POST,
                  payload.mediaUrl
                )
              : null;

          const fileURL =
            payload.file !== null
              ? await uploadTask(
                  `file${response.data.postID}`,
                  constants.TABLE.POST,
                  payload.file
                )
              : null;

          await postService.updatePost({
            postId: response.data.postID,
            mediaUrl: mediaURL,
            file: fileURL
          });
        } else {
          await postService.updatePost({
            postId: response.data.postID,
            mediaUrl: payload.mediaUrl,
            mediaType: payload.mediaType
          });
        }
        await postService.getPosts(payload).then((response: any) => {
          context.commit("setTotalPosts", response.data.totalPosts);
          context.commit("setPosts", response.data.posts);
        });
      });
      return created;
    },
    updatePost: async (context: any, payload: any) => {
      let updated = false;

      if (payload.newMediaFile !== undefined) {
        const newMediaFileURL = await uploadTask(
          payload.postId,
          constants.TABLE.POST,
          payload.newMediaFile
        );
        payload.mediaUrl = newMediaFileURL;
        payload.mediaType = payload.newMediaType;
        if (!payload.currentHosted) {
          if (payload.currentFile !== null) {
            await deleteTask(payload.currentMedia);
          }
        }
      }

      if (payload.newHostedURL !== undefined) {
        payload.mediaUrl = payload.newHostedURL;
        payload.mediaType = "HOSTED";
        if (!payload.currentHosted) {
          await deleteTask(payload.currentMedia);
        }
      }

      if (payload.newFile) {
        const file = await uploadTask(
          payload.postId,
          constants.TABLE.POST,
          payload.file
        );
        payload.file = file;
        await deleteTask(payload.currentFile);
      }

      await postService.updatePost(payload).then(async (response: any) => {
        updated = response.data.updated;
        await postService.getPosts(payload).then((response: any) => {
          context.commit("setTotalPosts", response.data.totalPosts);
          context.commit("setPosts", response.data.posts);
        });
      });
      return updated;
    },
    deletePost: async (context: any, payload: any) => {
      let deleted = false;
      await postService
        .deletePost(payload.postId)
        .then(async (response: any) => {
          deleted = response.data.deleted;
          if (
            payload.postMediaURL !== null &&
            payload.postMediaType !== "HOSTED"
          ) {
            await deleteTask(payload.postMediaURL);
          }

          if (payload.postFile !== null) {
            await deleteTask(payload.postFile);
          }

          await postService.getPosts(payload).then(async (response: any) => {
            if (payload.page > 1 && response.data.posts.length == 0) {
              payload.start =
                (payload.page - 1) * constants.ITEMS_PER_PAGE -
                constants.ITEMS_PER_PAGE;
              await postService.getPosts(payload).then((response: any) => {
                context.commit("setTotalPosts", response.data.totalPosts);
                context.commit("setPosts", response.data.posts);
              });
            } else {
              context.commit("setTotalPosts", response.data.totalPosts);
              context.commit("setPosts", response.data.posts);
            }
          });
        });
      return deleted;
    }
  }
};
